"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineSessionId = exports.defineAnonymousId = exports.isMarketingTrackingAllowed = exports.getCookieConsent = exports.SESSION_ID_EXPIRATION_ADDITIONAL_TIME = exports.COOKIE_CONSENT_KEY = exports.LOCAL_ANONYMOUSID_EXPIRATION_KEY = exports.LOCAL_ANONYMOUSID_KEY = exports.LOCAL_SESSIONID_EXPIRATION_KEY = exports.LOCAL_SESSIONID_KEY = void 0;
var analyticsInstance_1 = require("../analyticsInstance");
var cookieUtils_1 = require("./cookieUtils");
exports.LOCAL_SESSIONID_KEY = 'ac_session_id';
exports.LOCAL_SESSIONID_EXPIRATION_KEY = 'ac_session_id_expiration';
exports.LOCAL_ANONYMOUSID_KEY = 'ac_anonymous_id';
exports.LOCAL_ANONYMOUSID_EXPIRATION_KEY = 'ac_anonymous_id_expiration';
exports.COOKIE_CONSENT_KEY = 'cookieconsent';
exports.SESSION_ID_EXPIRATION_ADDITIONAL_TIME = 30;
var getCookieConsent = function () {
    var _a;
    var storedCookieConsent = JSON.parse((_a = (0, cookieUtils_1.getCookie)(exports.COOKIE_CONSENT_KEY)) !== null && _a !== void 0 ? _a : '{}');
    if ('marketingCookie' in storedCookieConsent) {
        return storedCookieConsent;
    }
    return {
        marketingCookie: false,
        preferenceCookie: false,
        statisticsCookie: false,
    };
};
exports.getCookieConsent = getCookieConsent;
var isMarketingTrackingAllowed = function () {
    return (0, exports.getCookieConsent)().marketingCookie;
};
exports.isMarketingTrackingAllowed = isMarketingTrackingAllowed;
var defineAnonymousId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var analytics, anonymousId, anonymousIdExpirationEntry, anonymouIdExpiration, now, localAnonymousId, oneYearFromNow;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, (0, analyticsInstance_1.getAnalyticsInstance)()];
            case 1:
                analytics = _c.sent();
                anonymousId = (_a = analytics.user().anonymousId()) !== null && _a !== void 0 ? _a : '';
                anonymousIdExpirationEntry = localStorage.getItem(exports.LOCAL_ANONYMOUSID_EXPIRATION_KEY);
                if (anonymousIdExpirationEntry !== null) {
                    anonymouIdExpiration = new Date(Number(anonymousIdExpirationEntry));
                    now = new Date();
                    if (anonymouIdExpiration.getTime() <= now.getTime()) {
                        localStorage.removeItem(exports.LOCAL_ANONYMOUSID_KEY);
                        localStorage.removeItem(exports.LOCAL_ANONYMOUSID_EXPIRATION_KEY);
                    }
                }
                localAnonymousId = localStorage.getItem(exports.LOCAL_ANONYMOUSID_KEY);
                if (localAnonymousId === null) {
                    oneYearFromNow = new Date().setFullYear(new Date().getFullYear() + 1);
                    localStorage.setItem(exports.LOCAL_ANONYMOUSID_KEY, anonymousId);
                    localStorage.setItem(exports.LOCAL_ANONYMOUSID_EXPIRATION_KEY, String(oneYearFromNow));
                }
                analytics.setAnonymousId(String((_b = localStorage.getItem(exports.LOCAL_ANONYMOUSID_KEY)) !== null && _b !== void 0 ? _b : ''));
                return [2 /*return*/];
        }
    });
}); };
exports.defineAnonymousId = defineAnonymousId;
var defineSessionId = function () {
    var now = Date.now();
    var nowPlusAdditionalTime = String(new Date().setMinutes(new Date().getMinutes() + exports.SESSION_ID_EXPIRATION_ADDITIONAL_TIME));
    var sessionIdExpirationEntry = Number(localStorage.getItem(exports.LOCAL_SESSIONID_EXPIRATION_KEY));
    if (sessionIdExpirationEntry !== null) {
        if (now >= sessionIdExpirationEntry) {
            localStorage.removeItem(exports.LOCAL_SESSIONID_KEY);
            localStorage.removeItem(exports.LOCAL_SESSIONID_EXPIRATION_KEY);
        }
        else {
            // if it hasn't expired yet, we keep the expiration range alive.
            localStorage.setItem(exports.LOCAL_SESSIONID_EXPIRATION_KEY, nowPlusAdditionalTime);
        }
    }
    var localSessionId = localStorage.getItem(exports.LOCAL_SESSIONID_KEY);
    if (localSessionId === null) {
        var sessionId = String(Date.now());
        localStorage.setItem(exports.LOCAL_SESSIONID_KEY, sessionId);
        localStorage.setItem(exports.LOCAL_SESSIONID_EXPIRATION_KEY, nowPlusAdditionalTime);
    }
    return Number(localStorage.getItem(exports.LOCAL_SESSIONID_KEY));
};
exports.defineSessionId = defineSessionId;
//# sourceMappingURL=trackingUtils.js.map